import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss']
})
export class CalendarComponent implements OnInit {

  @Input()
  public min: Date = null;

  @Input()
  public max: Date = null;

  @Input()
  public selected: Date = null;

  private _display: "days" | "months" = "days";

  @Input()
  public set display(value: "days" | "months") {
    this._display = value;
    this.move(0);
  }

  public get display(): "days" | "months" {
    return this._display;
  }

  @Output()
  public change: EventEmitter<Date> = new EventEmitter<Date>();

  constructor() { }

  private start: Date;
  public month: Date;

  ngOnInit(): void {

    if (this.min) {
      this.min = this.min.date();
      if (this.selected && this.selected.getTime() < this.min.getTime()) this.selected = this.min;
    }

    if (this.max) {
      this.max = this.max.date();

      if (this.min && this.min.getTime() > this.max.getTime()) {
        let buffer: Date = this.max;
        this.max = this.min;
        this.min = buffer;
      }

      if (this.selected && this.selected.getTime() > this.max.getTime()) this.selected = this.max;
    }    

    this.month = (this.selected ? this.selected : this.max ? this.max : this.min ? this.min : new Date()).beginOfMonth();
    this.move(0);
  }
  
  public day(index: number): number {
    return this.start.addDays(index).getDate();
  }

  public today(index: number): boolean {
    return this.start.addDays(index).getTime() == (new Date()).date().getTime();
  }

  public thisMonth(index: number): boolean {
    return this.start.beginOfMonth().addMonths(index).getTime() == (new Date()).beginOfMonth().getTime();
  }   

  public out(index: number): boolean {

    switch (this.display) {

      case "days":

        {
          let test: Date = this.start.addDays(index);

          if (test.getMonth() != this.month.getMonth()) return true;

          if (this.max && test.getTime() > this.max.getTime()) return true;
          if (this.min && test.getTime() < this.min.getTime()) return true;

          return false;
        }

      case "months":

        {
          let test: Date = this.start.beginOfYear().addMonths(index);

          if (this.max && test.getTime() > this.max.getTime()) return true;
          if (this.min && test.getTime() < this.min.getTime()) return true;

          return false;
        }

    }

    return true;
  }

  public active(index: number): boolean {

    switch (this.display) {
      case "days":
        return this.selected && this.start.addDays(index).getTime() == this.selected.date().getTime();

      case "months":
        return this.selected && this.start.addMonths(index).getTime() <= this.selected.date().getTime() && this.start.addMonths(index + 1).getTime() > this.selected.date().getTime();

      default: return false;
    }    
  }

  public select(index: number) {

    let test: Date;
    switch (this.display) {

      case "days":

        test = this.start.addDays(index);
        if (this.out(index)) return;

        break;

      case "months":

        test = this.start.addMonths(index);
        if (this.out(index)) return;

        break;
    }

    this.selected = test;
    this.change.emit(test);
  }

  public movable(months: number) {
    let test: Date = this.month.addMonths(months);

    if (this.min) {
      if (test.getFullYear() < this.min.getFullYear()) return false;
      if (test.getFullYear() == this.min.getFullYear() && test.getMonth() < this.min.getMonth()) return false;
    }

    if (this.max) {
      if (test.getFullYear() > this.max.getFullYear()) return false;
      if (test.getFullYear() == this.max.getFullYear() && test.getMonth() > this.max.getMonth() && this.display == "days") return false;
    }

    return true;
  }

  public move(months: number) {
    if (this.movable(months)) {

      this.month = this.month.addMonths(months);

      switch (this.display) {

        case "days":

          let offset = -this.month.getDay() + 1;
          this.start = this.month.addDays(offset > 0 ? offset - 7 : offset);
          break;

        case "months":

          this.start = this.month.beginOfYear();
          break;
      }

      
    }
  }
}
